import React from 'react';
import { ReduxFormFieldRenderInput } from 'components/input';
import {} from 'interfaces/forms';
import { replaceExistingAccountErrorFromProps } from './helpers';
const ReduxFormFieldRenderInputWithUpdatedErrors = (props) => (React.createElement(ReduxFormFieldRenderInput, { ...replaceExistingAccountErrorFromProps(props) }));
export default ReduxFormFieldRenderInputWithUpdatedErrors;
